(function(){
  'use strict';
  var root = document.getElementById('psh-root') || document;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = window.matchMedia('(pointer: fine) and (min-width: 1024px)').matches;
  var aria = document.getElementById('pshAria');
  function announce(msg){ if(aria) aria.textContent = msg; }

  /* ── HERO SLIDER (3 slides editoriais) ───────────────────── */
  (function heroSlider(){
    var track = document.getElementById('pshHeroTrack');
    if (!track) return;
    var slides = track.querySelectorAll('.psh-hero__slide');
    var total = slides.length;
    if (total < 2) return;

    var dots = document.querySelectorAll('#pshHeroDots .psh-hero__dot');
    var current = 0;
    var timer;
    var heroEl = root.querySelector('.psh-hero');
    var rawSpeed = parseInt(heroEl && heroEl.getAttribute('data-hero-speed'), 10) || 6500;
    /* Mobile: +25% para deixar tempo de leitura */
    var isMobile = window.matchMedia('(max-width: 899px)').matches;
    var AUTO_MS = isMobile ? Math.round(rawSpeed * 1.25) : rawSpeed;

    function go(n){
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].setAttribute('aria-current', 'false');
      current = ((n % total) + total) % total;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].setAttribute('aria-current', 'true');
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      announce('Slide ' + (current + 1) + ' de ' + total);
      reset();
    }
    function reset(){ if (prefersReduced) return; clearInterval(timer); timer = setInterval(function(){ go(current + 1); }, AUTO_MS); }

    root.querySelectorAll('[data-psh-hero="prev"]').forEach(function(b){ b.addEventListener('click', function(){ go(current - 1); }); });
    root.querySelectorAll('[data-psh-hero="next"]').forEach(function(b){ b.addEventListener('click', function(){ go(current + 1); }); });
    root.querySelectorAll('[data-psh-hero-go]').forEach(function(b){
      b.addEventListener('click', function(){ go(parseInt(b.getAttribute('data-psh-hero-go'), 10)); });
    });

    var sx = 0, sy = 0, drag = false;
    track.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; drag = true; }, { passive: true });
    track.addEventListener('touchend', function(e){
      if (!drag) return; drag = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    if (heroEl) {
      heroEl.addEventListener('keydown', function(e){
        if (e.key === 'ArrowLeft')  go(current - 1);
        if (e.key === 'ArrowRight') go(current + 1);
      });
      heroEl.addEventListener('mouseenter', function(){ clearInterval(timer); });
      heroEl.addEventListener('mouseleave', reset);
      heroEl.addEventListener('focusin', function(){ clearInterval(timer); });
      heroEl.addEventListener('focusout', reset);

      /* Pausa autoplay quando hero não está visível (poupa CPU + evita confusão) */
      if ('IntersectionObserver' in window) {
        var heroVisible = true;
        new IntersectionObserver(function(entries){
          heroVisible = entries[0].isIntersecting;
          if (heroVisible) reset(); else clearInterval(timer);
        }, { threshold: 0.25 }).observe(heroEl);
      }
    }

    reset();
  }());

  /* ── Visual viewport offset (segue chrome do browser mobile) ── */
  (function visualBottomOffset(){
    if (!window.visualViewport) return;
    var docEl = document.documentElement;
    function update(){
      var vv = window.visualViewport;
      var extra = Math.max(0, vv.height - window.innerHeight);
      docEl.style.setProperty('--psh-vv-bottom', extra + 'px');
    }
    window.visualViewport.addEventListener('resize', update);
    window.visualViewport.addEventListener('scroll', update);
    window.addEventListener('orientationchange', update);
    update();
  }());

  /* ── Sticky CTA: aparece após scroll do hero ─────────────────── */
  (function stickyCTA(){
    var cta = document.querySelector('[data-psh-sticky]');
    if (!cta) return;
    var hero = root.querySelector('.psh-hero');
    if (!hero || !('IntersectionObserver' in window)) {
      cta.classList.add('is-visible');
      return;
    }
    new IntersectionObserver(function(entries){
      // Quando hero sai do viewport, mostra sticky CTA
      cta.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '-30% 0px 0px 0px' }).observe(hero);
  }());

  /* ── Wishlist state hydration (localStorage) ─────────────────── */
  (function wishHydrate(){
    try {
      var saved = JSON.parse(localStorage.getItem('psh_wish') || '[]');
      if (!saved.length) return;
      root.querySelectorAll('[data-psh-wish]').forEach(function(btn){
        var id = parseInt(btn.getAttribute('data-psh-wish'), 10);
        if (saved.indexOf(id) >= 0) {
          btn.classList.add('is-on');
          btn.setAttribute('aria-label', 'Remover dos favoritos');
        }
      });
    } catch(e) {}
  }());

  /* ── IntersectionObserver: card reveal + lazy image + reveal ── */
  (function reveal(){
    if (!('IntersectionObserver' in window) || prefersReduced) {
      root.querySelectorAll('.psh-card, .psh-reveal').forEach(function(el){
        el.classList.add('psh-card--visible', 'is-visible');
      });
      root.querySelectorAll('.psh-card__img[data-src]').forEach(function(img){
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
        img.classList.add('is-loaded');
      });
      root.querySelectorAll('.psh-card__img:not([data-src])').forEach(function(img){ img.classList.add('is-loaded'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.classList.contains('psh-card')) el.classList.add('psh-card--visible');
        if (el.classList.contains('psh-reveal')) el.classList.add('is-visible');
        var img = el.querySelector ? el.querySelector('.psh-card__img[data-src]') : null;
        if (img) {
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src');
          img.addEventListener('load', function(){ img.classList.add('is-loaded'); }, { once: true });
          if (img.complete) img.classList.add('is-loaded');
        }
        io.unobserve(el);
      });
    }, { rootMargin: '120px 0px', threshold: 0.05 });

    root.querySelectorAll('.psh-card, .psh-reveal').forEach(function(el){ io.observe(el); });
  }());

  /* ── Counter animation ───────────────────────────────────── */
  (function counters(){
    function format(n){ return (n >= 1000 ? Math.round(n).toLocaleString('pt-PT') : String(Math.round(n))); }
    if (!('IntersectionObserver' in window) || prefersReduced) {
      root.querySelectorAll('[data-counter]').forEach(function(el){
        var raw = el.getAttribute('data-counter');
        var match = String(raw).match(/[\d.,]+/);
        if (!match) return;
        var num = parseFloat(match[0].replace(',', '.'));
        if (isNaN(num)) return;
        el.textContent = format(num) + String(raw).replace(match[0], '');
      });
      return;
    }
    function animateCount(el){
      var target = el.getAttribute('data-counter');
      var match = String(target).match(/[\d.,]+/);
      if (!match) return;
      var final = parseFloat(match[0].replace(',', '.'));
      if (isNaN(final)) return;
      var suffix = String(target).replace(match[0], '');
      var duration = 1700, start = performance.now();
      function tick(now){
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = format(final * eased) + suffix;
        if (t < 1) requestAnimationFrame(tick);
        else el.textContent = format(final) + suffix;
      }
      requestAnimationFrame(tick);
    }
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        animateCount(entry.target);
        cio.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    root.querySelectorAll('[data-counter]').forEach(function(el){ cio.observe(el); });
  }());

  /* ── Product carousels (iPhones / Favoritos) nav arrows ──── */
  (function productSliders(){
    root.querySelectorAll('[data-psh-slider]').forEach(function(slider){
      var track = slider.querySelector('[data-psh-slider-track]');
      var prev  = slider.querySelector('[data-psh-slider-prev]');
      var next  = slider.querySelector('[data-psh-slider-next]');
      if (!track) return;

      function cardWidth(){
        var card = track.querySelector('.psh-card');
        if (!card) return 280;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16);
        return card.offsetWidth + (isNaN(gap) ? 16 : gap);
      }
      function updateNav(){
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        prev.toggleAttribute('disabled', track.scrollLeft <= 1);
        next.toggleAttribute('disabled', track.scrollLeft >= max);
      }
      if (prev) prev.addEventListener('click', function(){
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function(){
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', function(){
        if (track._raf) return;
        track._raf = requestAnimationFrame(function(){
          updateNav();
          track._raf = null;
        });
      });
      var ro;
      if ('ResizeObserver' in window) {
        ro = new ResizeObserver(updateNav);
        ro.observe(track);
      } else {
        window.addEventListener('resize', updateNav);
      }
      updateNav();
    });
  }());

  /* ── Magnetic buttons ────────────────────────────────────── */
  (function magnetic(){
    if (!isDesktop || prefersReduced) return;
    var els = root.querySelectorAll('[data-magnetic]');
    els.forEach(function(el){
      var rect;
      el.addEventListener('mouseenter', function(){ rect = el.getBoundingClientRect(); });
      el.addEventListener('mousemove', function(e){
        if (!rect) rect = el.getBoundingClientRect();
        var dx = e.clientX - (rect.left + rect.width / 2);
        var dy = e.clientY - (rect.top + rect.height / 2);
        el.style.transform = 'translate(' + (dx * 0.18) + 'px,' + (dy * 0.22) + 'px)';
      });
      el.addEventListener('mouseleave', function(){
        el.style.transform = '';
        rect = null;
      });
    });
  }());

  /* ── View Transitions API (Chrome/Edge/Safari 2025+) ─────── */
  (function viewTransitions(){
    if (!('startViewTransition' in document) || prefersReduced) return;
    function isInternalLink(a){
      if (!a || !a.href) return false;
      if (a.target && a.target !== '_self') return false;
      if (a.hasAttribute('download')) return false;
      if (a.getAttribute('href').indexOf('#') === 0) return false;
      try {
        var u = new URL(a.href, location.href);
        return u.origin === location.origin && u.pathname !== location.pathname;
      } catch(_) { return false; }
    }
    document.addEventListener('click', function(e){
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || !isInternalLink(a)) return;
      e.preventDefault();
      document.startViewTransition(function(){ window.location.href = a.href; });
    });
  }());

  /* ── Before/After slider ─────────────────────────────────── */
  (function bafter(){
    var slider = document.getElementById('pshBafter');
    if (!slider) return;
    var handle = slider.querySelector('.psh-bafter__handle');
    var pos = 50;

    function setPos(p){
      pos = Math.max(0, Math.min(100, p));
      slider.style.setProperty('--bafter-x', pos + '%');
      if (handle) handle.setAttribute('aria-valuenow', Math.round(pos));
    }
    function clientX(e){ return e.touches ? e.touches[0].clientX : e.clientX; }
    function getPctFromEvent(e){
      var rect = slider.getBoundingClientRect();
      return ((clientX(e) - rect.left) / rect.width) * 100;
    }

    var dragging = false;
    function start(e){ dragging = true; slider.classList.add('is-dragging', 'is-touched'); setPos(getPctFromEvent(e)); }
    function move(e){ if (!dragging) return; if (e.cancelable) e.preventDefault(); setPos(getPctFromEvent(e)); }
    function end(){ if (!dragging) return; dragging = false; slider.classList.remove('is-dragging'); }

    slider.addEventListener('mousedown', start);
    document.addEventListener('mousemove', move);
    document.addEventListener('mouseup', end);
    slider.addEventListener('touchstart', start, { passive: true });
    document.addEventListener('touchmove', move, { passive: false });
    document.addEventListener('touchend', end);

    if (handle) {
      handle.addEventListener('keydown', function(e){
        var step = e.shiftKey ? 10 : 4;
        if (e.key === 'ArrowLeft')  { setPos(pos - step); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPos(pos + step); e.preventDefault(); }
        if (e.key === 'Home')       { setPos(0);   e.preventDefault(); }
        if (e.key === 'End')        { setPos(100); e.preventDefault(); }
      });
      handle.addEventListener('focus', function(){ slider.classList.add('is-touched'); });
    }

    if (!prefersReduced && 'IntersectionObserver' in window) {
      var iob = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (!entry.isIntersecting) return;
          var startTime = performance.now();
          var dur = 1800;
          function tick(now){
            var t = (now - startTime) / dur;
            if (t >= 1) { setPos(50); return; }
            var ease = Math.sin(t * Math.PI * 2) * (1 - t);
            setPos(50 + ease * 24);
            requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
          iob.unobserve(entry.target);
        });
      }, { threshold: 0.45 });
      iob.observe(slider);
    } else {
      setPos(50);
    }
  }());

  // ─── VÍDEO PROMO · mute toggle + pause-when-offscreen ──────
  (function vpromoInit(){
    var sections = document.querySelectorAll('.psh-vpromo');
    if (!sections.length) return;
    sections.forEach(function(sec){
      var video = sec.querySelector('.psh-vpromo__video');
      var btn   = sec.querySelector('[data-psh-vpromo-mute]');
      if (!video) return;
      // Mute toggle
      if (btn) {
        var iconOn  = btn.querySelector('.psh-vpromo__mute-on');
        var iconOff = btn.querySelector('.psh-vpromo__mute-off');
        btn.addEventListener('click', function(){
          video.muted = !video.muted;
          if (iconOn)  iconOn.style.display  = video.muted ? '' : 'none';
          if (iconOff) iconOff.style.display = video.muted ? 'none' : '';
          btn.setAttribute('aria-label', video.muted ? 'Activar som' : 'Silenciar');
          if (!video.paused) { video.play().catch(function(){}); }
        });
      }
      // Pause when offscreen (perf + UX)
      if ('IntersectionObserver' in window) {
        var iob = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if (e.isIntersecting) { video.play().catch(function(){}); }
            else { video.pause(); }
          });
        }, { threshold: 0.25 });
        iob.observe(video);
      }
    });
  }());

}());
